<ling-input-base
  [label]="label"
  [info]="info"
  [isRequired]="isRequired"
  [removeButton]="removeButton"
  [disabledInput]="disabledInput || optionsLoading"
  (removeButtonPress)="removeButtonPress.emit()"
  [error]="error"
>
  <div
    class="ling-input ling-select-input"
    #inputContainer
    (click)="onInputContainerClick()"
    [class.error-input]="error"
    [class.in-focus]="isFocused"
    [class.ling-select-input-opened]="dropdownOpened"
    [class.ling-select-input-opened-inverted]="
      dropdownOpened && (dropdownPosition$ | async)?.originY === 'top'
    "
    cdkOverlayOrigin
    #dropdownOrigin="cdkOverlayOrigin"
  >
    <mat-icon *ngIf="type === selectInputType.Icon"
              class="selected-value-icon">
      {{ searchInputText }}
    </mat-icon>
    <input
      #searchInput
      class="value-search"
      [value]="searchInputText"
      [placeholder]="placeholder"
      [class.disabled-input]="disabledInput || optionsLoading"
      [disabled]="!isSearchable || disabledInput || optionsLoading"
      (keydown.tab)="onTabPressed($event)"
      (input)="onSearchInput($event)"
    />
    <div
      class="ling-select-input__input-loader-container"
      *ngIf="!dropdownOpened && optionsLoading"
    >
      <mat-progress-spinner
        [mode]="'indeterminate'"
        [diameter]="20"
      ></mat-progress-spinner>
    </div>
    <div class="dropdown-toggle-button" (click)="onDropdownToggleButtonClick()">
      <mat-icon
        fontIcon="add"
        class="dropdown-toggle-button-icon"
        [class.dropdown-toggle-button-icon-opened]="dropdownOpened"
      >
      </mat-icon>
    </div>
  </div>
</ling-input-base>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="ling-dropdown"
  [cdkConnectedOverlayWidth]="inputContainer.getBoundingClientRect().width"
  [cdkConnectedOverlayOrigin]="dropdownOrigin"
  [cdkConnectedOverlayOpen]="dropdownOpened"
  [cdkConnectedOverlayPositions]="dropdownPositions"
  (positionChange)="dropdownPosition$.next($event.connectionPair)"
>
  <div
    #dropdown
    class="options-dropdown"
    [class.error-input]="error"
    [class.options-dropdown-inverted]="
      (dropdownPosition$ | async)?.originY === 'top'
    "
  >
    <ng-container *ngIf="dropdownDirection === 'up'">
      <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </ng-container>
    <div class="dropdown-options-container">
      <div
        *ngFor="let option of displayedOptions; let index = index"
        class="dropdown-option"
        [class.dropdown-option-selected]="
          (option.selected && mode === 'select') || mode === 'actions'
        "
        [class.dropdown-option-disabled]="option.disabled"
        (pointerover)="option.disabled ? '' : (highlightedOptionIndex = index)"
        (pointerleave)="highlightedOptionIndex = null"
        [class.highlighted-option]="highlightedOptionIndex === index"
        (click)="toggleOption(option)"
      >
        <ng-container *ngIf="type === selectInputType.Icon; else other">
          <mat-icon>{{ option.text }}</mat-icon>
          <p>{{ option.text }}</p>
        </ng-container>
        <ng-template #other>
          <span
            [innerHtml]="getOptionTextHTML(option.text)"
            class="dropdown-option__text"
          ></span>
        </ng-template>
        <span
          *ngIf="mode === 'select'"
          class="check-button"
          [class.hidden]="!multiple && !option.selected"
        >
          <mat-icon fontIcon="check" class="check-button-icon"></mat-icon>
        </span>
        <span *ngIf="mode === 'actions' && !option.disabled">
          <mat-icon
            fontIcon="add"
            class="action-option-icon"
            [class.action-option-icon-disabled]="dropdownOpened"
          >
          </mat-icon>
        </span>
      </div>
      <div
        class="dropdown-option no-results-option"
        *ngIf="!displayedOptions.length"
      >
        {{ noOptionsText }}
      </div>
      <mat-progress-spinner
        [diameter]="30"
        mode="indeterminate"
        *ngIf="optionsLoading"
        class="dropdown-options-container__scroll-loading-spinner"
      ></mat-progress-spinner>
    </div>
    <ng-container *ngIf="dropdownDirection === 'down'">
      <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </ng-container>
    <ng-template #buttons>
      <div class="dropdown-buttons" *ngIf="actionButton">
        <button
          type="button"
          tabindex="-1"
          #actionButtonEl
          [disabled]="!dropdownOpened"
          [class.highlighted-button]="highlightedOptionIndex === -1"
          (click)="onActionButtonClick()"
          mat-flat-button
          color="primary"
        >
          {{ actionButton }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>
